<template>
    <el-main>
        <div style="margin-bottom: 1rem;">
            <el-select v-model="sstj.yzcdlbbh" size="small" placeholder="请选择严重程度" style="margin-right: 20px;width: 15rem;" @change="qgQuery">
                <el-option
                    v-for="item in yzcds"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                >
                </el-option>
            </el-select>
            <el-select v-model="sstj.zt" size="small" placeholder="请选择状态" style="margin-right: 20px;width: 15rem;" @change="qgQuery">
                <el-option
                    v-for="item in zts"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id"
                >
                </el-option>
            </el-select>
            <el-date-picker
                size="small"
                style="margin-right: 20px;width: 30rem;"
                v-model="sstj.date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                @change="qgQuery"
            >
            </el-date-picker>
            <el-button type="primary" size="small" style="background-color: #a8a8a8;border: solid 0rem #f4f4f4;" @click="resetRwDataDeal">重置</el-button>
            <el-button type="primary" icon="el-icon-search" size="small" class="queryButton queryButtonPadding" @click="qgQuery">搜索</el-button>
        </div>
        <div class="commonDiv">
            <el-table
                :data="lxTableData"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                border
                ref="ryTableRef"
                size="mini"
                :row-style="tableRowClassName"
                style="width: 100%;"
                height="calc(100% - 60px)"
                :header-cell-style="{backgroundColor:'#f9f9ff',fontSize: '1.4rem',textAlign:'center',color:'#323232',fontFamily:'PingFang SC',fontWeight:'normal',fontStretch:'normal',height:'6.5vh'}"
            >
                <el-table-column prop="rwmc" label="任务名称" align="center">
                    <template slot-scope="scope">
                        <span style="color: #46adf5;cursor: pointer;" @click="seeYh(scope.row)">{{ scope.row.rwmc }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="zxr" label="执行人" align="center"/>
                <el-table-column prop="wtsj" label="发现时间" align="center"/>
                <el-table-column prop="wtmc" label="隐患名称" align="center"/>
                <el-table-column prop="hycnnm" label="隐患部位" align="center"/>
                <el-table-column prop="yzcdlbmc" label="严重程度" align="center">
                    <template slot-scope="scope">
                        <div>
                            <div v-if="scope.row.yzcdlbmc == '一般'" style="color: #F85600;">
                                {{ scope.row.yzcdlbmc }}
                            </div>
                            <div v-if="scope.row.yzcdlbmc == '严重'" style="color: #FF0D32;">
                                {{ scope.row.yzcdlbmc }}
                            </div>
                            <div v-if="scope.row.yzcdlbmc == '重大'" style="color: #FF0000;">
                                {{ scope.row.yzcdlbmc }}
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="zt" label="状态" align="center">
                    <template slot-scope="scope">
                        <div>
                            <div v-if="scope.row.zt == 1">
                                待解决
                            </div>
                            <div v-if="scope.row.zt == 2">
                                解决中
                            </div>
                            <div v-if="scope.row.zt == 3">
                                已解决
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="zgsj" label="解决时间" align="center"/>
                <el-table-column label="操作" align="center" width="150">
                    <template slot-scope="scope">
                        <div style="display: flex;justify-content: center;align-items: center;">
                            <span @click="seeDcyj(scope.row)" style="margin-right: 10px;">
                                <el-tooltip content="对策意见" effect="light">
                                    <img
                                        src="~@/assets/images/xc/dcyj.png"
                                        style="cursor: pointer;"
                                    />
                                </el-tooltip>
                            </span>
                            <span>
                                <el-tooltip content="选择是否解决" effect="light">
                                    <el-popover placement="right" width="400" trigger="manual" ref="popoverRef" v-model="scope.row.isZk">
                                        <div style="padding: 20px;">
                                            <el-radio-group v-model="ppzt.zt">
                                                <el-radio :label="'1'">待解决</el-radio>
                                                <el-radio :label="'2'">解决中</el-radio>
                                                <el-radio :label="'3'">已解决</el-radio>
                                            </el-radio-group>
                                            <div style="display: flex;justify-content: flex-end;margin-top: 20px;">
                                                <el-button @click="qxqx(scope.row)" class="dgClose">关闭</el-button>
                                                <el-button type="primary" @click="bcbc(scope.row)" class="dgSave">保存</el-button>
                                            </div>
                                        </div>
                                        <div slot="reference">
                                            <img
                                                src="~@/assets/images/xc/jj.png"
                                                style="cursor: pointer;"
                                                @click="onShow(scope.row)"
                                            />
                                        </div>
                                    </el-popover>
                                </el-tooltip>
                            </span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="commonPage2">
                <el-pagination
                    @size-change="lxHandleSizeChange"
                    @current-change="gzHandleCurrentChange"
                    :page-sizes="[10, 20, 30]"
                    :page-size="params.size"
                    :current-page="params.current"
                    layout="total, prev, pager, next,sizes, jumper"
                    background
                    :total="params.total"
                >
                </el-pagination>
            </div>
        </div>
        <data-dialog
            :dialog-title="ckDialog.title" 
            :is-visible="ckDialog.ryFormVisible" 
            :is-read="true"
            @dgVerifyDeal="dgVerifyDeal('ckDialog','dialog')" 
            ref="ckDialog" 
            @dgCancelDeal="seeCancelDeal"
            :dgStyle="dgSmallStyle"
            :is-own-style="true"
        >
            <div slot="dialogFrom">
                <el-form
                    ref="dialog"
                    :model="ckDialog.data"
                    :rules="lxRules"
                    label-position="top"
                    :disabled="ckisRead"
                >
                    <el-row>
                        <el-col :span="24">
                            <div style="display: flex;justify-content: space-between;padding: 20px 0;">
                                <div style="color: #545454;font-size: 16px;font-weight: 700;">{{ ckDialog.data.rwmc }}</div>
                                <div>发现时间：{{ ckDialog.data.wtsj }}</div>
                            </div>
                            <div style="background-color: #fbfbfb;padding: 20px;">
                                <div style="line-height: 20px;height: 20px;margin-bottom: 20px;">
                                    <el-col :span="12">
                                        <span>执&nbsp;&nbsp;行&nbsp;人：</span>
                                        {{ ckDialog.data.zxr }}
                                    </el-col>
                                    <el-col :span="12">
                                        隐患名称：{{ ckDialog.data.wtmc }}
                                    </el-col>
                                </div>
                                <div style="line-height: 20px;height: 20px;margin-bottom: 20px;">
                                    <el-col :span="12">
                                        隐患部位：{{ ckDialog.data.hycnnm }}
                                    </el-col>
                                    <el-col :span="12">
                                        严重程度：{{ ckDialog.data.yzcdlbmc }}
                                    </el-col>
                                </div>
                                <div style="line-height: 20px;height: 20px;">
                                    <el-col :span="12">
                                        状&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;态：{{ ckDialog.data.zt }}
                                    </el-col>
                                    <el-col :span="12">
                                        解决时间：{{ ckDialog.data.zgsj }}
                                    </el-col>
                                </div>
                            </div>
                            
                        </el-col>
                        <el-col :span="24">
                            <div style="padding: 20px 0;color: #545454;font-size: 16px;font-weight: 700;">隐患图片</div>
                            <div>
                                <div v-for="item in ckDialog.data.wtzpljList" :key="item" style="display: flex;">
                                    <img style="width: 200px;height:100%" :src="fileHost + item">
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </data-dialog>
        <data-dialog
            :dialog-title="dcDialog.title" 
            :is-visible="dcDialog.ryFormVisible" 
            :is-read="isAddData"
            @dgVerifyDeal="dgVerifyDeal('dcDialog','dialog')" 
            ref="dcDialog" 
            @dgConfirmDeal="dcConfirmDeal"
            @dgCancelDeal="dcCancelDeal"
            :dgStyle="dgSmallStyle"
            :is-own-style="true"
        >
            <div slot="dialogFrom">
                <el-form
                    ref="dialog"
                    :model="dcDialog.data"
                    :rules="lxRules"
                    :disabled="dcisRead"
                >
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="对策意见" prop="dcyj" style="width: 100%;">
                                <el-input
                                    type="textarea"
                                    :rows="5"
                                    placeholder="请输入内容"
                                    v-model="dcDialog.data.dcyj">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </data-dialog>
    </el-main>
</template>
  
<script>
import DataDialog from "../../components/tableGather/dataDialog";
import QueryGather from "../../components/buttonGather/queryGather";

import { fileHost } from "@/utils/config";

export default {
    components: {DataDialog, QueryGather},
    data() {
        return {
            fileHost:fileHost,
            dgSmallStyle: {
                height: '60%',
                marginTop: '0px',
                width: '35vw',
            },
            authorityMap: {
                isAdd: false,//新增权限
                isUpdate: false,//修改权限
                isDel: false,//删除权限
                isView: false,//查看权限
            },
            stRemHeight: 0,

            ppzt:{},
            lxTableData: [],
            lxRules: {
                mc: [
                    {required: true, message: "请输入路线名称", trigger: "blur"},
                ],
                lbbh: [
                    {required: true, message: "请选择任务类型", trigger: "blur"},
                ],
                xclxid: [
                    {required: true, message: "请选择巡查路线", trigger: "blur"},
                ],
                userid: [
                    {required: true, message: "请选择执行人", trigger: "blur"},
                ],
                kssj: [
                    {required: true, message: "请选择计划执行日期", trigger: "blur"},
                ],
                jssj: [
                    {required: true, message: "请选择计划结束日期", trigger: "blur"},
                ],
            },
            params: {
                total: 1,
                size: 10,
                current: 1,
            },
            sstj:{
                zt:'',
                yzcdlbbh:'',
                date:[],
            },
            loading: false,
            
            zts:[
                {id: 1, label: "待解决"},
                {id: 2, label: "解决中"},
                {id: 3, label: "已解决"},
            ],
            yzcds:[],

            
            ckDialog: {
                title: "",
                ryFormVisible: false,
                data: {},
            },
            ckisRead:true,

            dcDialog:{
                title: "",
                ryFormVisible: false,
                data: {},
            },
            dcisRead:true,
            isAddData:true,
        }
    },
    created() {
        let windowHeight = document.documentElement.clientHeight || document.bodyclientHeight;
        this.stRemHeight = windowHeight / 100;
    },
    mounted() {
        this.initStaffData();
        this.getYzcdData();
    },
    watch: {
        "$store.state.head.skCd"() {
            this.resetRwDataDeal();
        }
    },
    methods: {
        getYzcdData(){
            this.request.get('/rm-sdictionary/v1/query/15').then(res => {
                if (res.ok) {
                    this.yzcds = res.data;
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
        initStaffData() {
            // this.pageAuthorityDeal();
            this.getYhwtData();
        },
        pageAuthorityDeal() {
            const thirdAuthority = JSON.parse(localStorage.getItem("thirdAuthority"))
            const qx = thirdAuthority[this.$route.name];
            if (qx === 'all' || qx === null) {
                this.authorityMap.isAdd = true;
                this.authorityMap.isDel = true;
                this.authorityMap.isUpdate = true;
                this.authorityMap.isView = true;
            } else {
                this.authorityMap.isAdd = qx.indexOf('新增') !== -1;
                this.authorityMap.isDel = qx.indexOf('删除') !== -1;
                this.authorityMap.isUpdate = qx.indexOf('修改') !== -1;
                this.authorityMap.isView = qx.indexOf('查询') !== -1;
            }
        },
        
        resetRwDataDeal() {
            this.sstj = {
                zt:'',
                yzcdlbbh:'',
                date:[],
            };
            this.getYhwtData();
        },
        
        initGetRwData() {
            this.params = {
                total: 0,
                size: 10,
                current: 1,
            };
            this.getYhwtData();
        },
        qgQuery(params) {
            this.params.current = 1;
            this.getYhwtData();
        },
        
        tableRowClassName({row, rowIndex}) {
            return {
                backgroundColor: '#ffffff',
                fontSize: '1.4rem',
                fontWeight: 'normal',
                fontStretch: 'normal',
                fontFamily: 'PingFang SC',
                color: '#616f7b',
                height: '5.83vh',
            };
        },
        
        getYhwtData() {
            this.loading = true;
            let params = {
                ...this.params,
                ...this.sstj,
                sjGE:this.sstj.date[0],
                sjLE:this.sstj.date[1],
            }
            this.request.get('/rm-xxcrwwt/v1/queryXcwtPage', {params: params}).then(res => {
                if (res.ok) {
                    this.lxTableData = [];
                    this.lxTableData = res.data.records;
                } else {
                    this.$message.error(res.error.message);
                }
                this.loading = false;
            });
        },
        lxHandleSizeChange(val) {
            this.params.size = val;
            this.params.current = 1;
            this.getYhwtData();
        },
        //切换页码
        gzHandleCurrentChange(val) {
            this.params.current = val;
            this.getYhwtData();
        },


        onShow(row){
            this.ppzt = JSON.parse(JSON.stringify(row));
            row.isZk = true;
        },
        qxqx(row){
            row.isZk = false;
            // this.$refs.popoverRef.doClose();
            this.getYhwtData();
        },
        bcbc(row){
            let params = {
                id: row.id,
                zt: this.ppzt.zt,
            }
            this.request.get('/rm-xxcrwwt/v1/dealXcwt', {params: params}).then(res => {
                if (res.ok) {
                    this.$message.success('修改状态成功！');
                    this.qxqx(row);
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
        
        seeDcyj(row) {
            this.request.get('/rm-xxcrwwt/v1/queryXcwtDetail?id='+ row.id).then(res => {
                if (res.ok) {
                    this.dcDialog.data = res.data;
                    this.dcDialog.title = '查看对策意见';
                    if (this.dcDialog.data.dcyj) {
                        this.isAddData = true;
                        this.dcisRead = true;
                    } else {
                        this.isAddData = false;
                        this.dcisRead = false;
                    }
                    this.dcDialog.ryFormVisible = true;
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
        dcConfirmDeal(){
            let params = {
                id:this.dcDialog.data.id,
                dcyj:this.dcDialog.data.dcyj,
            }
            this.request.get('/rm-xxcrwwt/v1/dcyj', {params: params}).then(res => {
                if (res.ok) {
                    this.$message.success('提交对策意见成功！');
                    this.dcDialog.ryFormVisible = false;
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
        dcCancelDeal() {
            if (this.dcDialog.ryFormVisible) {
                this.dcDialog.ryFormVisible = false;
                this.$refs['dialog'].clearValidate();
            }
        },
        seeYh(row){
            this.request.get('/rm-xxcrwwt/v1/queryXcwtDetail?id='+ row.id).then(res => {
                if (res.ok) {
                    this.ckDialog.data = res.data;
                    if (this.ckDialog.data.zt == 1) {
                        this.ckDialog.data.zt = '待解决';
                    } else if (this.ckDialog.data.zt == 2) {
                        this.ckDialog.data.zt = '解决中';
                    } else if (this.ckDialog.data.zt == 3) {
                        this.ckDialog.data.zt = '已解决';
                    }
                } else {
                    this.$message.error(res.error.message);
                }
            });

            this.ckDialog.title = '日常巡查隐患问题';
            this.ckDialog.ryFormVisible = true;
        },
        seeCancelDeal() {
            if (this.ckDialog.ryFormVisible) {
                this.ckDialog.ryFormVisible = false;
                this.$refs['dialog'].clearValidate();
            }
        },


        dgVerifyDeal(dgRef, frRef) {
            this.$refs[frRef].validate((valid) => {
                if (valid) {
                    this.$refs[dgRef].isShowPop(true);
                } else {
                    this.$refs[dgRef].isShowPop(false);
                }
            });
        },
    },
}
</script>
<style scoped>
.commonDiv {
    position: relative;
    background-color: #FFFFFF;
    height: calc(100vh - 200px);
}
::v-deep .el-pagination{
    white-space: nowrap;
    color: #303133;
    font-weight: 700;
    transform: translate(0, -50%);
    position: relative;
    top: 50%;
    right: 20px;
}
.commonPage2 {
    position: absolute;
    right: 1.5rem;
    height: 60px;
}

.input-class /deep/ .el-input__inner {
    border-radius: 30px;
}

.dgClose {
    width: 8vh;
    height: 3vh;
    font-family: PingFang SC;
    font-size: 1.2vh;
    font-weight: normal;
    font-stretch: normal;
    line-height: 3vh;
    letter-spacing: 0vh;
    color: #0066ff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: solid 1px #53abfd;
    border-radius: 2px;
}
.dgSave {
    width: 8vh;
    height: 3vh;
    background-color: #53abfd;
    border-radius: 0vh;
    font-family: PingFang SC;
    font-size: 1.2vh;
    font-weight: normal;
    font-stretch: normal;
    line-height: 3vh;
    letter-spacing: 0vh;
    color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
}
</style>
  